import { gql } from "lib/apolloClient";
import { feedListFragment } from "./SettingFragments";

export const getUserFeedListQuery = gql`
  query getUserFeedList(
    $organizationId: ID!
    $input: MessageV2UserInput
    $totalCountInput: MessageV2UserInput
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        messageV2Users(input: $input) {
          allTotalCount: totalCount(input: $totalCountInput)
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            node {
              ...userFeedItems
            }
          }
        }
      }
    }
  }
  ${feedListFragment.userFeedItems}
`;

export const getChannelsFeedQuery = gql`
  query getChannelsFeedQuery(
    $organizationId: ID!
    $input: AllChatFeedInput
    $totalCountInput: AllChatFeedInput
    $isCurrentUserIncluded: Boolean = false
    $currentUserInput: UserV2Input
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        allChats(input: $input) {
          pageInfo {
            hasNextPage
            endCursor
          }
          allTotalCount: totalCount(input: $totalCountInput)
          totalCount(input: $input)
          edges {
            node {
              id
              label
              isArchived
              totalUsersCount
              currentUser: usersV2(input: $currentUserInput)
                @include(if: $isCurrentUserIncluded) {
                totalCount(input: $currentUserInput)
              }
            }
          }
        }
      }
    }
  }
`;

export const getOrganizationCoursesQuery = gql`
  query getOrganizationCourses(
    $organizationId: ID!
    $courseFilters: CourseFilterInput
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        id
        courses(
          orderBy: TITLE
          orderByDirection: ASC
          filters: $courseFilters
        ) {
          edges {
            node {
              id
              title
              grades {
                id
                name
              }
            }
          }
        }
      }
    }
  }
`;

export const getChatUsersQuery = gql`
  query getChatUsers($id: ID!, $input: UserV2Input) {
    node(id: $id, type: CHAT) {
      ... on Chat {
        id
        usersV2(input: $input) {
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            node {
              id
              firstName
              lastName
              profileImage
            }
          }
        }
      }
    }
  }
`;

export const getMessageV2UserDetailQuery = gql`
  query getMessageV2UserDetail(
    $organizationId: ID!
    $input: MessageV2UserInput
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        messageV2Users(input: $input) {
          edges {
            node {
              id
              ... on User {
                firstName
                middleName
                lastName
                type
                profileImage

                ... on Student {
                  preferredName
                  pronouns
                  prefix
                  suffix
                  isArchived
                  courses {
                    id
                    title
                    isArchived
                  }
                }

                ... on Staff {
                  preferredName
                  pronouns
                  prefix
                  suffix
                  isArchived
                  displayRole
                  courses {
                    id
                    title
                    isArchived
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

// configuration queries

export const getConfigurationQuery = gql`
  query getConfiguration(
    $configurationEntityGroupFilters: [ConfigurationEntityGroupFilter!]
  ) {
    platform {
      configuration(
        filters: {
          configurationEntityGroupFilters: $configurationEntityGroupFilters
        }
      ) {
        configurations {
          id
          uidV2
          configuration
          valueType
          value
          isLocked
          disabledEntityGroups(filters: { entityTypeGroups: [GRADE] }) {
            entities {
              entityId
              entityType
            }
          }
        }
      }
    }
  }
`;

export const getPreferenceQuery = gql`
  query getPreference(
    $configurationEntityGroupFilters: [ConfigurationEntityGroupFilter!]
  ) {
    platform {
      preferences(
        filters: {
          configurationEntityGroupFilters: $configurationEntityGroupFilters
        }
      ) {
        configurations {
          id
          uidV2
          configuration
          valueType
          value
          isLocked
          disabledEntityGroups(filters: { entityTypeGroups: [GRADE] }) {
            entities {
              entityId
              entityType
            }
          }
        }
      }
    }
  }
`;

export const getOrganizationGradesQuery = gql`
  query getOrganizationGrades(
    $organizationId: ID!
    $filters: GradeFilterInput
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      ... on Organization {
        id
        grades(filters: $filters) {
          id
          name
          curriculumProgram {
            id
            label
          }
        }
      }
    }
  }
`;

export const getChildrenYearGroupGradeQuery = gql`
  query getChildrenYearGroupGrade($id: ID!, $organizationId: ID) {
    node(id: $id, type: FAMILY_MEMBER) {
      id
      ... on FamilyMember {
        children(organizationId: $organizationId) {
          id
          yearGroup {
            id
            grade {
              id
            }
          }
        }
      }
    }
  }
`;
